import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
    withStyles, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography
} from "@material-ui/core";
import CancelAcceptForm from "../../../../Common/CancelAcceptForm";
import t from "../../../../../languages/pl";
import {buttonStyle} from "../buttonGroupStyle";
import {compose} from 'recompose';
import {KeyboardDatePicker} from "@material-ui/pickers";
import {dateTimePickerFormat, displayDateFormat} from "../../../../../utils/staticData";
import moment from "moment-timezone";
import {putCarEvidence} from "../../../../../store/actions/carsAction";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ClearButton from '@material-ui/icons/Clear';


const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        margin: theme.spacing(1),
        textAlign: "center"
    },
    row: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    spaceBefore: {
        marginLeft: 32
    },
    textfield: {
        width: 250,
        margin: theme.spacing(1)
    },
    requiredFields: {
        fontSize: 10,
        marginTop: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        color: "red",
    },
});

const initialState = {
    ewidencja_poczatek: 0,
    ewidencja_koniec: 0,
};

const CarEvidences = props => {
    const {classes, autoId, name, onDialogOpen, nonAdminUser, carEvidence, putCarEvidence} = props;
    const [open, setOpen] = useState(false);
    const [state, setState] = useState(initialState);

    const handleDialogOpen = () => {
        setOpen(true);
        onDialogOpen && onDialogOpen();
    };

    useEffect(() => {
        setState(carEvidence)
    }, [carEvidence])

    const handleSubmit = () => {
        putCarEvidence(autoId, state)

    };

    const clearPeriod = () => {
        setState(initialState)
    }

    const handleStartTimeChange = (e) => {
        let newDate = moment(e).unix();
        setState({
            ...state,
            ewidencja_poczatek: newDate
        });
    };

    const handleEndTimeChange = (e) => {
        let newDate = moment(e).unix();
        setState({
            ...state,
            ewidencja_koniec: newDate
        });
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.carEvidencesButtonLabel}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="sm"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.carEvidencesButtonLabel} {name}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.container}>
                        <div className={classes.row}>
                            <KeyboardDatePicker
                                className={classes.formField}
                                label={t.carEvidencesStartLabel}
                                invalidDateMessage={t.invalidDateFormat}
                                InputLabelProps={{
                                    shrink: true,
                                    classes: {root: classes.label}
                                }}
                                ampm={false}
                                variant="inline"
                                format={displayDateFormat}
                                value={!state.ewidencja_poczatek || state.ewidencja_poczatek === 0 ? null : moment.unix(state.ewidencja_poczatek).format(dateTimePickerFormat)}
                                onChange={handleStartTimeChange}
                            />
                            <KeyboardDatePicker
                                className={classes.formField}
                                label={t.carEvidencesEndLabel}
                                invalidDateMessage={t.invalidDateFormat}
                                InputLabelProps={{
                                    shrink: true,
                                    classes: {root: classes.label}
                                }}
                                ampm={false}
                                variant="inline"
                                minDate={!state.ewidencja_poczatek || state.ewidencja_poczatek === 0 ? null : moment.unix(state.ewidencja_poczatek).format(dateTimePickerFormat)}
                                format={displayDateFormat}
                                value={!state.ewidencja_koniec || state.ewidencja_koniec === 0 ? null : moment.unix(state.ewidencja_koniec).format(dateTimePickerFormat)}
                                onChange={handleEndTimeChange}
                            />
                            <Tooltip title={t.evidenceClearPeriod}>
                                <IconButton
                                    onClick={clearPeriod}
                                    aria-label="upload picture"
                                    className={classes.spaceBefore}
                                    component="span">
                                    <ClearButton/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <CancelAcceptForm
                        onCancel={() => setOpen(false)}
                        onSubmit={handleSubmit}
                        disableSubmit={nonAdminUser}
                        cancelName={t.close}
                    />
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );
};

CarEvidences.propTypes = {
    classes: PropTypes.object,
    autoId: PropTypes.number,
    name: PropTypes.string,
    onDialogOpen: PropTypes.func,
    onSubmit: PropTypes.func,
    nonAdminUser: PropTypes.bool
};

const mapStateToProps = ({carsReducer}) => ({
    carEvidence: carsReducer.carEvidence
});

export default compose(
    withStyles(useStyles),
    connect(mapStateToProps, {putCarEvidence})
)(CarEvidences);
